import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import { FavoritesProvider } from "./lib/FavoritesContext";
import { lazy, Suspense, useEffect } from "react";
import ImmobilienangebotPage from "./pages/Immobilienangebot";
import { FilterProvider } from "@/lib/FilterContext";
import ExposePage from "@/pages/ExposePage";
import LeadForm from "@/components/form/FormBewerten";
import BlogList from "@/components/blogs/BlogList";
import PostSample from "@/components/blogs/PostSample";
import FloatingIcons from "@/components/navigation/FloatingIcons";
import FormLandingpage from "@/components/form/FormLandingpage";
import Landingpage from "@/pages/Landingpage";
import VerkaufenLandingpage from "@/pages/VerkaufenLandingpage";
import SuchProfilForm from "@/components/form/SuchprofilForm";
import Referenzen from "@/pages/Referenzen";
import MotionTestPage from "@/pages/MotionTestPage";
import BeratungsTerminPage from "@/pages/BeratungsTerminPage";
import ScrollToTopButton from "@/components/navigation/ScrollToTopButton";
import { AnimatePresence, motion } from "framer-motion";
import VermietenLandingpage from "@/pages/VermietenLandingpage";
import UeberUns from "@/pages/company/UeberUnsPage";
import KontaktPage from "@/pages/company/ContactPage";
import Datenschutz from "@/pages/legal/Datenschutz";
import Impressum from "@/pages/legal/Impressum";
import MetaPixel from "@/lib/meta/maetaPixel";
const CookieConsent = lazy(() => import("@/components/test/Legal/Cookies"));
import ScrollToTop from "@/lib/scrollToTop";


// A reusable page transition wrapper component.
const PageTransition = ({ children }) => {
  const variants = {
    initial: { opacity: 0, transformOrigin: "center" },
    animate: { opacity: 1, transformOrigin: "center" },
    exit: { opacity: 0, transformOrigin: "center" },
  };

  return (
<AnimatePresence mode="wait">
  <motion.div
    key={location.pathname} // or another unique key per page
    initial="initial"
    animate="animate"
    exit="exit"
    variants={variants}
    transition={{ type: "tween", duration: 0.4 }}
    style={{ transformOrigin: "center" }}
    className="relative"
  >
    <ScrollToTop />
    {children}
  </motion.div>
</AnimatePresence>
  );
};

// Extracted animated routes component to leverage useLocation for transitions.
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <PageTransition>
              <Landingpage />
            </PageTransition>
          }
        />
        <Route
          path="/beratungstermin"
          element={
            <PageTransition>
              <BeratungsTerminPage />
            </PageTransition>
          }
        />
          <Route
          path="/vermieten"
          element={
            <PageTransition>
              <VermietenLandingpage />
            </PageTransition>
          }
        />
        <Route
          path="/testing"
          element={
            <PageTransition>
              <MotionTestPage />
            </PageTransition>
          }
        />
        <Route path="/immobilien">
          <Route
            index
            element={
              <PageTransition>
                <ImmobilienangebotPage />
              </PageTransition>
            }
          />
          <Route
            path="suchprofil-anlegen"
            element={
              <PageTransition>
                <SuchProfilForm />
              </PageTransition>
            }
          />
          <Route
            path=":type"
            element={
              <PageTransition>
                <VerkaufenLandingpage />
              </PageTransition>
            }
          />
        </Route>
        <Route
          path="/expose/:id"
          element={
            <PageTransition>
              <ExposePage />
            </PageTransition>
          }
        />
        <Route path="/ratgeber">
          <Route
            index
            element={
              <PageTransition>
                <BlogList />
              </PageTransition>
            }
          />
          <Route
            path=":slug"
            element={
              <PageTransition>
                <PostSample />
              </PageTransition>
            }
          />
        </Route>
        <Route path="/bewerten">
          <Route
            index
            element={
              <PageTransition>
                <FormLandingpage />
              </PageTransition>
            }
          />
          <Route path=":type">
            <Route
              index
              element={
                <PageTransition>
                  <FormLandingpage />
                </PageTransition>
              }
            />
            <Route
              path="online-bewertung"
              element={
                <PageTransition>
                  <LeadForm />
                </PageTransition>
              }
            />
          </Route>
        </Route>
        <Route path="/verkaufen">
          <Route
            index
            element={
              <PageTransition>
                <VerkaufenLandingpage />
              </PageTransition>
            }
          />
          <Route
            path=":type"
            element={
              <PageTransition>
                <VerkaufenLandingpage />
              </PageTransition>
            }
          />
        </Route>
        <Route path="/unternehmen">
          <Route
            index
            element={
              <PageTransition>
                <UeberUns />
              </PageTransition>
            }
          />
          <Route
            path="über-uns"
            element={
              <PageTransition>
                <UeberUns />
              </PageTransition>
            }
          />
          <Route
            path="kontakt"
            element={
              <PageTransition>
                <KontaktPage />
              </PageTransition>
            }
          />
        </Route>
        <Route path="/rechtliches">
          <Route
            index
            element={
              <PageTransition>
                <UeberUns />
              </PageTransition>
            }
          />
          <Route
            path="impressum"
            element={
              <PageTransition>
                <Impressum />
              </PageTransition>
            }
          />
          <Route
            path="datenschutz"
            element={
              <PageTransition>
                <Datenschutz />
              </PageTransition>
            }
          />
        </Route>
        <Route
          path="/referenzen"
          element={
            <PageTransition>
              <Referenzen />
            </PageTransition>
          }
        />
        {/* 404 catch-all route */}
      <Route
          path="*"
          element={
            <PageTransition>
              <div className="min-h-screen flex items-center justify-center">
                <div className="text-center flex flex-col items-center justify-center space-y-5">
                  <img className="mb-10" src="/jakobs_logo.png" alt="" />
                  <h1 className="text-4xl font-bold mb-4">404</h1>
                  <p className="text-xl">Seite nicht gefunden</p>
                  <Link className="underline text-prime-600 font-medium" to={"/"}>Hier geht es zurück zur Startseite</Link>
                </div>
              </div>
            </PageTransition>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};

function App() {

 

  return (
    <>
    <MetaPixel />
      <ScrollToTopButton />
      <Suspense fallback={null}>
        <CookieConsent />
      </Suspense>
      <BrowserRouter>
      <FilterProvider>
        <FavoritesProvider>
            <AnimatedRoutes />
        </FavoritesProvider>
      </FilterProvider>
      </BrowserRouter>

      <FloatingIcons />
    </>
  );
}

export default App;
